import React from "react";
import { Modal } from "react-bootstrap";

function StatusModal(props) {
  return (
    <Modal
      show={props.statusModal}
      onHide={props.onHide}
      backdrop="static"
      keyboard={false}
      centered
      className="Upload-trade-license"
    >
      <Modal.Header
        closeButton
        className=" px-4 justify-content-between "
        style={{ borderBottom: "1px solid #f0f0f0" }}
      >
        <Modal.Title>Status</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="px-4 modal-full-text"
        style={{ backgroundColor: "#ffffff" }}
      >
        {/* --- STATUS LIST UI START --- */}

        <div>
          <div className="mb-3">
            <h6 className="fw-bold text-muted">Not Started</h6>
            <p className="text-muted small">
              You haven’t added any details or documents for this section yet.
            </p>
          </div>

          <div className="mb-3">
            <h6 className="fw-bold " style={{ color: "#158332" }}>
              Submitted
            </h6>
            <p className="text-muted small">
              All required details and documents have been successfully added.
            </p>
          </div>

          <div className="mb-3">
            <h6 className="fw-bold text-primary">In Progress</h6>
            <p className="text-muted small">
              Required details and/or documents have been partially added.
            </p>
          </div>

          <div className="mb-3">
            <h6 className="fw-bold text-warning">Under Review</h6>
            <p className="text-muted small">
              The Zelo team is currently reviewing the information provided.
            </p>
          </div>

          <div className="mb-3">
            <h6 className="fw-bold " style={{ color: "#158332" }}>
              Approved
            </h6>
            <p className="text-muted small">
              The Zelo team has reviewed and approved the information provided.
            </p>
          </div>

          <div className="mb-3">
            <h6 className="fw-bold " style={{ color: "#B22D2D" }}>
              Rejected
            </h6>
            <p className="text-muted small">
              This section was reviewed and rejected. You’ll need to resubmit
              the correct information.
            </p>
          </div>

          <div className="mb-3">
            <h6 className="fw-bold" style={{ color: "#e9a700" }}>
              Needs Attention
            </h6>
            <p className="text-muted small">
              The Zelo team has flagged certain items that need your action
              before approval.
            </p>
          </div>
        </div>
        {/* --- STATUS LIST UI END --- */}
      </Modal.Body>
    </Modal>
  );
}

export default StatusModal;
